var map = {
	"./about.png": 6500,
	"./aero.png": 8667,
	"./antimatter.png": 724,
	"./battery.png": 845,
	"./carbon.png": 3689,
	"./carnelian.png": 6278,
	"./cog.png": 5504,
	"./communication.png": 2489,
	"./darkmatter.png": 9010,
	"./discord.png": 1706,
	"./donating.png": 2633,
	"./dyson.png": 7835,
	"./emc.png": 5111,
	"./energy.png": 5167,
	"./engine.png": 9580,
	"./floor1.png": 2080,
	"./floor2.png": 5039,
	"./floor3.png": 9960,
	"./fuel.png": 6887,
	"./gem.png": 3977,
	"./gold.png": 693,
	"./helium.png": 7297,
	"./help.png": 6965,
	"./hyacinite.png": 6427,
	"./hydrogen.png": 5402,
	"./ice.png": 1689,
	"./innerSolarSystem.png": 6062,
	"./kitrinos.png": 6236,
	"./kofi.png": 5088,
	"./lava.png": 3445,
	"./lunarite.png": 7162,
	"./metal.png": 6146,
	"./meteorite.png": 3543,
	"./methane.png": 5662,
	"./military.png": 4472,
	"./moviton.png": 7124,
	"./nanoswarm.png": 9569,
	"./nanoswarm_green.png": 3776,
	"./oil.png": 3329,
	"./outerSolarSystem.png": 5160,
	"./overlord.png": 2726,
	"./patreon.png": 684,
	"./paypal.png": 3727,
	"./plasma.png": 3150,
	"./prasnian.png": 7386,
	"./probe.png": 8954,
	"./rank.png": 6909,
	"./rocket.png": 2385,
	"./science.png": 9582,
	"./segment.png": 8192,
	"./shield.png": 9227,
	"./silicon.png": 4823,
	"./silver.png": 4239,
	"./solCenter.png": 3084,
	"./spaceship.png": 246,
	"./technologies.png": 2400,
	"./terraformer.png": 2455,
	"./terraforming.png": 3806,
	"./titanium.png": 9824,
	"./titans.png": 652,
	"./travel.png": 3459,
	"./trophy.png": 9905,
	"./ultrite.png": 5357,
	"./upgrades.png": 8893,
	"./uranium.png": 9085,
	"./wonderStation.png": 532,
	"./wood.png": 5344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5035;